import { FiMail, FiPhoneCall } from 'react-icons/fi';
import logo from '../asssets/img/Net-Price-Calculator.png';
import s from './Header.module.css';

export const Header = () => {
  return (
    <div className={s.headerContainer}>
      <div className={s.logo}>
        <img className={s.logoImg} src={logo} alt="Logo" />
      </div>
      <div className={s.menu}>
        <ul className={s.menuList}>
          <li className={s.menuItem}>
            <FiMail className={s.menuIcon} />
            <a className={s.menuLink} href="mailto:gamerspeed86@gmail.com">
              gamerspeed86@gmail.com
            </a>
          </li>
          <li className={s.menuItem}>
            <FiPhoneCall className={s.menuIcon} />
            <a className={s.menuLink} href="tel:+380961111111">
              +380961111111
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};
